import React from "react";
import { Card, CardBody, Col, UncontrolledTooltip } from "reactstrap";
import Avatar from "react-avatar";
import ShieldCheckIcon from "mdi-react/ShieldCheckIcon";
import * as users from "../../../../../../shared/service/users";
import { Link } from "react-router-dom";
import Slider from "react-slide-out";
import ProfileEnrich from "./ProfileEnrich";
import LabelFormatter from "./../../../LableFormatter";
import Login from "./Login";
import Modal from "../../../../../../shared/modal";

class ProfileMain extends React.Component {
  state = {
    first_name: "Loading ...",
    showLogin: false,
    url: "https://",
    show: false,
    success: "",
    errors: [],
  };

  componentDidMount() {
    users.getProfile(this.props.id).then((response) => {
      this.setState(response);
    });
  }

  userLogin = () => {
    users.getAuthToken(this.state.email).then((res) => {
      this.setState({
        showLogin: true,
        url:
          users.getLoginUrl() +
          "/#/login/recover/" +
          res.token +
          "/" +
          window.localStorage.getItem("X-Auth-AdminID"),
      });
    });
  };

  sendRecoverPasswordEmail = () => {
    users.sendRecoverPasswordEmail(this.state.email).then((res) => {
      if (res._user_message_type === "success") {
        this.setState({
          show: true,
          success: `Reset password link sent successfully at ${this.state.email}.`,
        });
      } else {
        this.setState({
          show: true,
          errors: [
            `Error while generating reset password link, contact to administrator.`,
          ],
        });
      }
    });
  };

  emailVerified = () =>
    this.state.email_verified === 1 ||
    this.state.email_verified === "true" ||
    this.state.email_verified === true ? (
      <React.Fragment>
        <ShieldCheckIcon size={20} color="#66d568" id="userEmail" />
        <UncontrolledTooltip placement="top" target="userEmail">
          Account is admin verified.
        </UncontrolledTooltip>
      </React.Fragment>
    ) : (
      ""
    );

  phoneVerified = () =>
    this.state.sms_verified === 1 ||
    this.state.sms_verified === "true" ||
    this.state.sms_verified === true ? (
      <React.Fragment>
        <ShieldCheckIcon size={20} color="#66d568" id="userphoneNumber" />
        <UncontrolledTooltip placement="top" target="userphoneNumber">
          Phone number is verified!
        </UncontrolledTooltip>
      </React.Fragment>
    ) : (
      ""
    );

  render() {
    return (
      <React.Fragment>
        <Col md={12} lg={12} xl={12}>
          <Card>
            <CardBody className="profile__card">
              <div className="profile__information">
                <div className="profile__avatar">
                  <Avatar
                    name={this.state.first_name + " " + this.state.last_name}
                    round
                  />
                </div>
                <div className="profile__data">
                  <p className="profile__name">
                    {this.state.first_name} {this.state.last_name}
                  </p>
                  <p className="profile__work">{this.state.company_name}</p>
                  <p className="profile__contact">
                    {this.emailVerified()}
                    {this.state.email}
                  </p>
                  <p className="profile__contact">
                    {this.phoneVerified()}
                    {this.state.phone}
                  </p>
                  <div className="table">
                    <LabelFormatter value={this.state.status} />
                  </div>
                </div>
                <div className="profile__stat">
                  <Link
                    to={() => {
                      return false;
                    }}
                    onClick={() => this.setState({ isOpen: true })}
                  >
                    Show More
                  </Link>
                </div>
              </div>
              <div className="profile__stats">
                <div className="profile__stat">
                  <p className="profile__stat-number">{this.state.traffic}</p>
                  <p className="profile__stat-title">Bandwidth Used</p>
                </div>
                <div className="profile__stat">
                  <p className="profile__stat-number">
                    <span
                      className="lnr lnr-lock"
                      onClick={(e) => this.sendRecoverPasswordEmail()}
                    ></span>
                  </p>
                  <p className="profile__stat-title">
                    Reset Password <br />
                    Email
                  </p>
                </div>
                <div className="profile__stat">
                  <p className="profile__stat-number">
                    <span
                      className="lnr lnr-enter-down"
                      onClick={(e) => this.userLogin()}
                    ></span>
                  </p>
                  <p className="profile__stat-title">Login</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() => this.setState({ isOpen: false })}
              >
                Close
              </button>
            </div>
          }
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <ProfileEnrich id={this.props.id} />
        </Slider>
        <Login
          onClose={() => this.setState({ showLogin: false })}
          show={this.state.showLogin}
          url={this.state.url}
        ></Login>
        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </React.Fragment>
    );
  }
}

export default ProfileMain;
